<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h5>
        {{ headline }}
      </h5>
    </div>

    <div class="panel-body">
      <form @submit.prevent="$emit('submit', data)">
        <TextFormGroup
            v-model="data.title"
            name="title"
            label="Title"
            help-text="The title of the registration."
            :error="(errors.title || [])[0]"
        />

        <CkEditorFormGroup
            v-model="data.text"
            name="text"
            label="Text"
            help-text="The text of the registration."
            :error="(errors.text || [])[0]"
        />

        <TextFormGroup
            v-if="edit"
            v-model="data.path"
            name="path"
            label="Path"
            help-text="The path of the registration."
            :error="(errors.path || [])[0]"
        />

        <SelectFormGroup
            v-model="data.content_registration_category_id"
            name="content_registration_category_id"
            label="Category"
            :error="(errors.content_registration_category_id || [])[0]"
            :options="contentRegistrationCategoryOptions"
        />

        <GalleryFormGroup
            v-model="data.image_id"
            name="image_id"
            label="Image"
            :error="(errors.image_id || [])[0]"
            :company-id="companyId"
        />

        <RepeatableFormGroup
            label="Gallery"
            v-model="data.gallery_images"
            help-text="The gallery that is attached to the registration."
            :errors="galleryImagesErrors"
        >
          <template v-slot:default="{ data, index, change, errors }">
            <GalleryFormGroup
                :value="data.image_id"
                :name="'gallery_images.' + index + '.image_id'"
                label="Image"
                :error="(errors.image_id || [])[0]"
                :company-id="companyId"
                @input="change(index, 'image_id', $event)"
            />
          </template>
        </RepeatableFormGroup>

        <SubmitFormGroup button-class="btn-black"/>
      </form>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import GalleryFormGroup from "../../../FormGroups/Block/Gallery"
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Block/Submit'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'
import CkEditorFormGroup from '@/vendor/forms/FormGroups/Block/CkEditor'
import RepeatableFormGroup from "../../../Forms/RepeatableFormGroup.vue";

export default {
  components: {
    RepeatableFormGroup,
    GalleryFormGroup,
    SelectFormGroup,
    SubmitFormGroup,
    TextFormGroup,
    CkEditorFormGroup,
  },

  props: {
    headline: {
      required: true,
      type: String
    },

    initial: {
      required: false,
      type: Object,
      default: () => ({})
    },

    errors: {
      required: true,
      type: Object
    },

    companyId: {
      required: true,
      type: [String, Number]
    },

    contentRegistrationCategories: {
      required: true,
      type: Array
    },

    edit: {
      required: false,
      default: false,
      type: Boolean
    }
  },

  data() {
    return {
      data: {...this.initial},

      shared: store
    }
  },

  computed: {
    galleryImagesErrors() {
      return Object.entries(this.errors)
          .filter(entry => entry[0].startsWith('gallery_images.'))
          .reduce((result, entry) => ({
            ...result,
            [entry[0].substring('gallery_images.'.length)]: entry[1]
          }), {})
    },

    contentRegistrationCategoryOptions() {
      return this.contentRegistrationCategories.map(contentRegistrationCategory => ({
        value: contentRegistrationCategory.id,
        label: contentRegistrationCategory.attributes.name
      }))
    }
  }
}
</script>